import React, { useState } from "react";
import { Link } from "react-router-dom";
import Select from "react-select";
import { ChevronDown, Info, PlusCircle } from "react-feather";
import { all_routes } from "../../Router/all_routes";
import {  renderRequired} from "../../feature-module/common/common.js";
const ManageEnquiry = () => {
  const route = all_routes;
  const getTodayDate = () => {
    const today = new Date();
    return today.toISOString().split("T")[0]; // Returns 'YYYY-MM-DD' format
  };

  // Function to get the date 350 days from today
  const getAutoReminderDate = () => {
    const reminderDate = new Date();
    reminderDate.setDate(reminderDate.getDate() + 350);
    return reminderDate.toISOString().split("T")[0];
  };
  const [formData, setFormData] = useState({
    enquiryDate: getTodayDate(),
    autoReminderDate: getAutoReminderDate(),
    client: null,
    clientInfo: {
      contactPersons: [{ department: "", designation: "", mobileNumber: "", mailId: "" }],
    },
    services: [],
    ccEmails: [],
    totalManpower: "",
    plantsCovered: "",
    majorProduct: "",
    hazardousChemicals: "",
    pesoStorageLicence: "",
    plotArea: "",
    constructionArea: "",
  });
  

  // const [errors, setErrors] = useState({});

  const clientOptions = [
    {
      value: "client1",
      label: "Client 1",
      clientName: "ABC Corp",
      unitName: "Unit 1",
      unitLocation: "Location A",
      contactPersons: [
        {
          designation: "Manager",
          department: "Sales",
          mobile: "1234567890",
          email: "manager@abc.com",
        },
      ],
    },
    {
      value: "client2",
      label: "Client 2",
      clientName: "XYZ Corp",
      unitName: "Unit 2",
      unitLocation: "Location B",
      contactPersons: [
        {
          designation: "Lead",
          department: "Marketing",
          mobile: "9876543210",
          email: "lead@xyz.com",
        },
      ],
    },
  ];

  const serviceOptions = [
    { value: "service1", label: "Service 1" },
    { value: "service2", label: "Service 2" },
  ];

  const handleSelectChange = (field) => (selectedOption) => {
    if (field === "client") {
      const { clientName, unitName, unitLocation, contactPersons } =
        selectedOption;
      setFormData({
        ...formData,
        client: selectedOption,
        clientInfo: {
          clientName,
          unitName,
          unitLocation,
          contactPersons,
        },
      });
    } else {
      setFormData({
        ...formData,
        [field]: selectedOption,
      });
    }
  };
  const addContactPersonForm = () => {
    setFormData({
      ...formData,
      clientInfo: {
        ...formData.clientInfo,
        contactPersons: [
          ...formData.clientInfo.contactPersons,
          { designation: "", department: "", mobile: "", email: "" },
        ],
      },
    });
  };
  const removeContactPersonForm = (index) => {
    const updatedContactPersons = formData.clientInfo.contactPersons.filter(
      (_, i) => i !== index
    );
    setFormData({
      ...formData,
      clientInfo: {
        ...formData.clientInfo,
        contactPersons: updatedContactPersons,
      },
    });
  };
  const [errors, setErrors] = useState({});
  const handleChange = (e) => {
    const { name, value } = e.target;
  
    // Update form data
    setFormData({
      ...formData,
      [name]: value,
    });
  
    // Clear the error for the field if it's valid now
    if (errors[name]) {
      setErrors({
        ...errors,
        [name]: null,
      });
    }
  };

  const handleServiceChange = (index, field, value) => {
    const updatedServices = formData.services.map((service, i) =>
      i === index ? { ...service, [field]: value } : service
    );
    setFormData({ ...formData, services: updatedServices });
  };

  const handleAddService = () => {
    setFormData({
      ...formData,
      services: [...formData.services, { service: null, quantity: 1 }],
    });
  };

  const handleRemoveService = (index) => {
    const updatedServices = formData.services.filter((_, i) => i !== index);
    setFormData({ ...formData, services: updatedServices });
  };

  const handleContactPersonChange = (index, field, value) => {
    const updatedContacts = formData.clientInfo.contactPersons.map(
      (person, i) => (i === index ? { ...person, [field]: value } : person)
    );
    setFormData({
      ...formData,
      clientInfo: {
        ...formData.clientInfo,
        contactPersons: updatedContacts,
      },
    });
  };

  const handleAddEmail = () => {
    setFormData({
      ...formData,
      ccEmails: [...formData.ccEmails, ""],
    });
  };

  const handleRemoveEmail = (index) => {
    const updatedEmails = formData.ccEmails.filter((_, i) => i !== index);
    setFormData({ ...formData, ccEmails: updatedEmails });
  };

  const handleEmailChange = (index, value) => {
    const updatedEmails = formData.ccEmails.map((email, i) =>
      i === index ? value : email
    );
    setFormData({ ...formData, ccEmails: updatedEmails });
  };

  const validateForm = () => {
    const newErrors = {};
  
    if (!formData.enquiryDate) newErrors.enquiryDate = "Date of Enquiry is required.";
    if (!formData.autoReminderDate) newErrors.autoReminderDate = "Auto Reminder Date is required.";
    if (!formData.client) newErrors.client = "Client is required.";
    if (!formData.clientName) newErrors.clientName = "Client Name is required.";
    if (!formData.unitName) newErrors.unitName = "Unit Name is required.";
    if (!formData.unitLocation) newErrors.unitLocation = "Unit Location is required.";
    if (!formData.designation) newErrors.designation = "Designation is required.";
    if (!formData.department) newErrors.department = "Department is required.";
    if (!formData.contactPerson) newErrors.contactPerson = "Contact Person is required.";
    if (!formData.contactEmail || !/\S+@\S+\.\S+/.test(formData.contactEmail)) {
      newErrors.contactEmail = "Valid Contact Email is required.";
    }
    if (!formData.services || formData.services.length === 0) newErrors.services = "At least one Service is required.";
    if (!formData.quantity) newErrors.quantity = "Quantity is required.";
    if (!formData.totalManpower) newErrors.totalManpower = "Total Manpower is required.";
    if (!formData.plantsCovered) newErrors.plantsCovered = "Plants Covered is required.";
    if (!formData.majorProduct) newErrors.majorProduct = "Major Product is required.";
    if (!formData.hazardousChemicals) newErrors.hazardousChemicals = "Hazardous Chemicals is required.";
    if (!formData.pesoStorageLicence) newErrors.pesoStorageLicence = "PESO Storage Licence is required.";
    if (!formData.plotArea) newErrors.plotArea = "Plot Area is required.";
    if (!formData.constructionArea) newErrors.constructionArea = "Construction Area is required.";
  
    formData.ccEmails.forEach((email, index) => {
      if (!email || !/\S+@\S+\.\S+/.test(email)) {
        newErrors[`ccEmail_${index}`] = `Valid CC Email ${index + 1} is required.`;
      }
    });
  
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    console.log("Form Data:", formData);
  };


  return (
    <div className="page-wrapper mb-3">
      <div className="content ">
        {/* Enquiry Info Section */}

        <div
          className="accordion-card-one accordion "
          id="accordionEnquiryInfo"
        >
          <div className="accordion-item p-3 ">
            <div className="accordion-header m-3 p-3" id="headingEnquiryInfo">
              <div
                className="accordion-button d-flex justify-content-between"
                data-bs-toggle="collapse"
                data-bs-target="#collapseEnquiryInfo"
                aria-controls="collapseEnquiryInfo"
              >
                <h5>
                  <Info className="add-info" />
                  <span className="ms-1">Enquiry Info</span>
                </h5>
                <Link to="#">
                  <ChevronDown className="chevron-down-add" />
                </Link>
              </div>
            </div>
            <div
              id="collapseEnquiryInfo"
              className="accordion-collapse collapse show"
              aria-labelledby="headingEnquiryInfo"
            >
              <div className="accordion-body p-3">
                <div className="row ">
                  <div className="col-lg-4 col-sm-6 col-12">
                    <div className="mb-3 add-product">
                      <label className="form-label">
                        Date of Enquiry {renderRequired()}
                      </label>
                      <input
                        type="date"
                        className="form-control"
                        name="enquiryDate"
                        value={formData.enquiryDate}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="col-lg-4 col-sm-6 col-12">
                    <label className="form-label">Auto Reminder Date </label>
                    <input
                      type="date"
                      className="form-control"
                      name="autoReminderDate"
                      value={formData.autoReminderDate}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-lg-4 col-sm-6 col-12">
                    <div className="mb-3 add-product">
                      <label className="form-label">
                        Client {renderRequired()}
                      </label>
                      <Select
                        options={clientOptions}
                        value={formData.client}
                        onChange={handleSelectChange("client")}
                      />
                       {errors.client && <span className="text-danger">{errors.client}</span>}
                    </div>
                  </div>
                  {/* Display Client Information */}
                  {formData.client && (
                    <>
                      <div className="row">
                        <div className="col-lg-4 col-sm-6 col-12">
                          <div className="mb-3 add-product">
                            <label className="form-label">
                              Client Name {renderRequired()}
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              value={formData.clientInfo.clientName}
                            />
                             {errors.clientName && <span className="text-danger">{errors.clientName}</span>}
                          </div>
                        </div>

                        <div className="col-lg-4 col-sm-6 col-12">
                          <div className="mb-3 add-product">
                            <label className="form-label">
                              Unit Name {renderRequired()}
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              value={formData.clientInfo.unitName}
                            />
                             {errors.unitName && <span className="text-danger">{errors.unitName}</span>}
                          </div>
                        </div>

                        <div className="col-lg-4 col-sm-6 col-12">
                          <div className="mb-3 add-product">
                            <label className="form-label">
                              Unit Location {renderRequired()}
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              value={formData.clientInfo.unitLocation}
                            />
                             {errors.unitLocation && <span className="text-danger">{errors.unitLocation}</span>}
                          </div>
                        </div>
                        {/* Contact Person Details */}
                        {formData.clientInfo.contactPersons.map(
                          (person, index) => (
                            <div className="col-12" key={index}>
                              <div className=" d-flex  align-items-center mb-3">
                                <labe>Contact Person {index + 1}</labe>
                                <spam
                                  className="d-flex justify-content-end align-items-center"
                                  style={{ color: "$warning" }}
                                >
                                  <i
                                    className="bx bx-x-circle"
                                    style={{
                                      fontSize: "20px",
                                      justifyContent: "center",
                                      borderRadius: "50px",
                                      color: "#FF9F43",
                                      border: "1px",
                                      paddingLeft: "5px",
                                    }}
                                    onClick={() =>
                                      removeContactPersonForm(index)
                                    }
                                  />
                                </spam>
                              </div>

                              <div className="row">
                                <div className="col-lg-6 col-sm-6 col-12">
                                  <div className="mb-3 add-product">
                                    <label className="form-label">
                                      Designation {renderRequired()}
                                    </label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      placeholder="Designation"
                                      value={person.designation}
                                      onChange={(e) =>
                                        handleContactPersonChange(
                                          index,
                                          "designation",
                                          e.target.value
                                        )
                                      }
                                    />
                                     {errors.designation && <span className="text-danger">{errors.designation}</span>}
                                  </div>
                                </div>
                                <div className="col-lg-6 col-sm-6 col-12">
                                  <div className="mb-3 add-product">
                                    <label className="form-label">
                                      Department {renderRequired()}
                                    </label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      placeholder="Department"
                                      value={person.department}
                                      onChange={(e) =>
                                        handleContactPersonChange(
                                          index,
                                          "department",
                                          e.target.value
                                        )
                                      }
                                    />
                                     {errors.department && <span className="text-danger">{errors.department}</span>}
                                  </div>
                                </div>
                                <div className="col-lg-6 col-sm-6 col-12">
                                  <div className="mb-3 add-product">
                                    <label className="form-label">
                                      {" "}
                                      Contact Person {renderRequired()}
                                    </label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      placeholder="Mobile"
                                      value={person.mobile}
                                      onChange={(e) =>
                                        handleContactPersonChange(
                                          index,
                                          "mobile",
                                          e.target.value
                                        )
                                      }
                                    />
                                     {errors.contactPerson && <span className="text-danger">{errors.contactPerson}</span>}
                                  </div>
                                </div>
                                <div className="col-lg-6 col-sm-6 col-12">
                                  <div className="mb-3 add-product">
                                    <label className="form-label">
                                      {" "}
                                      Contact Email {renderRequired()}
                                    </label>
                                    <input
                                      type="email"
                                      className="form-control"
                                      placeholder="Email"
                                      value={person.email}
                                      onChange={(e) =>
                                        handleContactPersonChange(
                                          index,
                                          "email",
                                          e.target.value
                                        )
                                      }
                                    />
                                    {errors.contactEmail && <span className="text-danger">{errors.contactEmail}</span>}
                                  </div>
                                </div>
                              </div>
                            </div>
                          )
                        )}
                      </div>
                      <div className="d-flex justify-content-end mb-4">
                        <button
                          type="button"
                          className="btn btn-primary mb-4"
                          onClick={addContactPersonForm}
                        >
                          <PlusCircle className="me-2" />
                          Add Contact Person
                        </button>
                      </div>
                    </>
                  )}
                  {/* Services with Add/Remove functionality */}
                  {formData.services.map((service, index) => (
                    <div className="col-12" key={index}>
                      <div className="row">
                        <div className="col-lg-4 col-sm-6 col-12">
                          <div className="mb-3 add-product">
                            <label className="form-label">
                              service {renderRequired()}
                            </label>
                            <Select
                              options={serviceOptions}
                              value={service.service}
                              onChange={(value) =>
                                handleServiceChange(index, "service", value)
                              }
                            />
                            {errors.service && <span className="text-danger">{errors.service}</span>}
                          </div>
                        </div>
                        <div className="col-lg-4 col-sm-6 col-12">
                          <div className="mb-3 add-product">
                            <label className="form-label">
                              Quantity {renderRequired()}
                            </label>
                            <input
                              type="number"
                              className="form-control"
                              value={service.quantity}
                              onChange={(e) =>
                                handleServiceChange(
                                  index,
                                  "quantity",
                                  e.target.value
                                )
                              }
                            />
                            {errors.quantity && <span className="text-danger">{errors.quantity}</span>}
                          </div>
                        </div>
                        <spam
                          className="col-lg-4 col-sm-6 col-12 d-flex justify-content-start align-items-center"
                          style={{ color: "$warning" }}
                        >
                          <i
                            className="bx bx-x-circle"
                            style={{
                              fontSize: "20px",
                              justifyContent: "center",
                              borderRadius: "50px",
                              color: "#FF9F43",
                              border: "1px",
                              paddingLeft: "5px",
                            }}
                            onClick={() => handleRemoveService(index)}
                          />{" "}
                        </spam>
                      </div>
                    </div>
                  ))}
                  {/* <div className="d-flex justify-content-end mb-3"> */}
                  <button
                    type="button"
                    className="btn btn-primary me-4 mb-3"
                    onClick={handleAddService}
                  >
                    Add Service
                  </button>
                </div>
                {/* </div> */}
              </div>
            </div>
          </div>
        </div>

        {/* Pre-Proposal Checklist Section */}
        <div
          className="accordion-card-one accordion"
          id="accordionPreProposalChecklist"
        >
          <div className="accordion-item p-3">
            <div
              className="accordion-header p-3"
              id="headingPreProposalChecklist"
            >
              <div
                className="accordion-button d-flex justify-content-between"
                data-bs-toggle="collapse"
                data-bs-target="#collapsePreProposalChecklist"
                aria-controls="collapsePreProposalChecklist"
              >
                <h5>
                  <Info className="add-info" />
                  <span className="ms-1">Pre-Proposal Checklist</span>
                </h5>
                <Link to="#">
                  <ChevronDown className="chevron-down-add" />
                </Link>
              </div>
            </div>
            <div
              id="collapsePreProposalChecklist"
              className="accordion-collapse collapse show"
              aria-labelledby="headingPreProposalChecklist"
            >
              <div className="accordion-body">
                <div className="row p-5">
                  <div className="col-lg-4 col-sm-6 col-12">
                    <div className="mb-3 add-product">
                      <label className="form-label">
                        Total Manpower {renderRequired()}
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        name="totalManpower"
                        value={formData.totalManpower}
                        onChange={handleChange}
                      />
                       {errors.totalManpower && <span className="text-danger">{errors.totalManpower}</span>}
                    </div>
                  </div>

                  <div className="col-lg-4 col-sm-6 col-12">
                    <div className="mb-3 add-product">
                      <label className="form-label">
                        Plants Covered {renderRequired()}
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="plantsCovered"
                        value={formData.plantsCovered}
                        onChange={handleChange}
                      />
                       {errors.plantsCovered && <span className="text-danger">{errors.plantsCovered}</span>}
                    </div>
                  </div>

                  <div className="col-lg-4 col-sm-6 col-12">
                    <div className="mb-3 add-product">
                      <label className="form-label">
                        Major Product {renderRequired()}
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="majorProduct"
                        value={formData.majorProduct}
                        onChange={handleChange}
                      />
                       {errors.majorProduct && <span className="text-danger">{errors.majorProduct}</span>}
                    </div>
                  </div>

                  <div className="col-lg-4 col-sm-6 col-12">
                    <div className="mb-3 add-product">
                      <label className="form-label">
                        Hazardous Chemicals {renderRequired()}
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="hazardousChemicals"
                        value={formData.hazardousChemicals}
                        onChange={handleChange}
                      />
                       {errors.hazardousChemicals && <span className="text-danger">{errors.hazardousChemicals}</span>}
                    </div>
                  </div>

                  <div className="col-lg-4 col-sm-6 col-12">
                    <div className="mb-3 add-product">
                      <label className="form-label">
                        PESO Storage Licence {renderRequired()}
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="pesoStorageLicence"
                        value={formData.pesoStorageLicence}
                        onChange={handleChange}
                      />
                       {errors.pesoStorageLicence && <span className="text-danger">{errors.pesoStorageLicence}</span>}
                    </div>
                  </div>

                  <div className="col-lg-4 col-sm-6 col-12">
                    <div className="mb-3 add-product">
                      <label className="form-label">
                        Plot Area (sq. m.) {renderRequired()}
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="plotArea"
                        value={formData.plotArea}
                        onChange={handleChange}
                      />
                       {errors.plotArea && <span className="text-danger">{errors.plotArea}</span>}
                    </div>
                  </div>

                  <div className="col-lg-4 col-sm-6 col-12">
                    <div className="mb-3 add-product">
                      <label className="form-label">
                        Construction Area (sq. m.) {renderRequired()}
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="constructionArea"
                        value={formData.constructionArea}
                        onChange={handleChange}
                      />
                       {errors.pesoStorageLicence && <span className="text-danger">{errors.pesoStorageLicence}</span>}
                    </div>
                  </div>

                  {/* CC Emails */}
                  {formData.ccEmails.map((email, index) => (
                    <div className="col-lg-4 col-sm-6 col-12" key={index}>
                      <div className="mb-3 add-product">
                        <label className="form-label">
                          CC Email {index + 1} {renderRequired()}
                        </label>
                        <div className="d-flex">
                          <input
                            type="email"
                            className="form-control"
                            value={email}
                            onChange={(e) =>
                              handleEmailChange(index, e.target.value)
                            }
                          />
                          <spam
                            className="col-lg-4 col-sm-6 col-12 d-flex justify-content-start align-items-center"
                            style={{ color: "$warning" }}
                          >
                            <i
                              className="bx bx-x-circle"
                              style={{
                                fontSize: "20px",
                                justifyContent: "center",
                                borderRadius: "50px",
                                color: "#FF9F43",
                                border: "1px",
                                paddingLeft: "5px",
                              }}
                              onClick={() => handleRemoveEmail(index)}
                            />{" "}
                          </spam>
                        </div>
                        {errors[`ccEmail_${index}`] && <span className="text-danger">{errors[`ccEmail_${index}`]}</span>}
                      </div>
                    </div>
                  ))}
       
                  {/* <div className="d-flex justify-content-end mb-4"> */}
                    <button
                      type="button"
                      className="btn btn-primary mb-2"
                      onClick={handleAddEmail}
                    >
                      Add CC Email
                    </button>
                  {/* </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Submit Button */}
        <div className="m-3 ">
          <div className="d-flex justify-content-end m-3 ">
            <button type="button" className="btn btn-secondary me-2">
              <Link
                to={route.dashboard}
                className="text-decoration-none text-light"
              >
                Cancel
              </Link>
            </button>
            <button
              type="submit"
              className="btn btn-primary"
              onClick={handleSubmit}
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ManageEnquiry;

